import { useEventListener } from '@vueuse/core';
import { isHtmlElement } from '@/js/helpers/type-guards/isHtmlElement';

const COLLAPSE_CLASS = '.collapse-component';
const HEADER_CLASS = '.collapse-component-header';
const CONTENT_CLASS = '.collapse-component-content';

const getContentHeight = (element: HTMLDivElement): number | null => {
    const contentElement = element.querySelector<HTMLDivElement>(CONTENT_CLASS);

    const height = contentElement.offsetHeight;

    return height || null;
};

const hideCollapseContent = (element: HTMLDivElement) => {
    const contentElement = element.querySelector<HTMLDivElement>(CONTENT_CLASS);

    if (contentElement) {
        contentElement.style.maxHeight = '0';
        contentElement.style.opacity = '1';
        contentElement.style.position = 'relative';
    }
};

const addCollapseLogic = (event: MouseEvent, element: HTMLDivElement) => {
    if (!isHtmlElement(event.target)) {
        return;
    }

    const clickedElement = event.target;
    const contentElement = element.querySelector<HTMLDivElement>(CONTENT_CLASS);

    if (contentElement && clickedElement.closest(HEADER_CLASS)) {
        const isCollapsed = contentElement.style.maxHeight === '0px' || !contentElement.style.maxHeight;

        contentElement.style.maxHeight = isCollapsed
            ? `${contentElement.scrollHeight}px`
            : '0px';
    }
};

const addCollapseLogicToElements = () => {
    const collapseElements = document.querySelectorAll<HTMLDivElement>(COLLAPSE_CLASS);

    collapseElements.forEach((element) => {
        const contentHeight: number | null = getContentHeight(element);

        if (contentHeight !== null) {
            hideCollapseContent(element);
            useEventListener(
                element,
                'click',
                (event) => addCollapseLogic(event, element),
            );
        }
    });
};

useEventListener(document, 'DOMContentLoaded', addCollapseLogicToElements);
